<template>
    <h1>{{ display_name }}</h1>
    <ul class="actions">
      <li class="share">
        <share-button></share-button>
      </li>
      <li class="like">
        <like-button
          :id="shop.id"
          :liked="shop.user_liked_flag"
          :like-count="shop.liked"
          like-style="icon"
          :content-type="1"
          :auth="auth"
        >
        </like-button>
      </li>
    </ul>
    <div class="location">
      <ol>
        <li>
          <a href="#" @click.stop="search('island', shop.areaInfo.island_id)">
            {{ shop.areaInfo.island_name }}
          </a>
        </li>
        <li>
          <a href="#" @click.stop="search('area', shop.areaInfo.area_id)">
            {{ shop.areaInfo.area_name }}
          </a>
        </li>
      </ol>
    </div>
    <!-- <div class="reviewStars">
      <div class="stars">
        <div class="star" :class="{ filled: this.shop.star_count >= 1 }"></div>
        <div class="star" :class="{ filled: this.shop.star_count >= 2 }"></div>
        <div class="star" :class="{ filled: this.shop.star_count >= 3 }"></div>
        <div class="star" :class="{ filled: this.shop.star_count >= 4 }"></div>
        <div class="star" :class="{ filled: this.shop.star_count >= 5 }"></div>
      </div>
      <div class="num">{{ this.shop.star_count ?? 0 }}</div>
    </div> -->
    <div class="likes">
      <div class="icon"></div>
      <like-count
        :like-count="shop.liked"
        :id="shop.id"
        like-style="count"
        :content-type="1"
      >
      </like-count>
    </div>
</template>

<script>
export default {
  props: {
    shop: Object,
    display_name: String,
    link: String,
    auth: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: this.shop.areaInfo.name,
      text: "",
      url: this.shop.areaInfo.url,
      search_word: null,
      isCopyMessage: false,
    };
  },
  mounted() {
    this.getParam();
  },
  methods: {
    getParam() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      this.search_word = urlParams.get("search_word");
    },
    search(key, id) {
      const url = new URL(this.link);
      if (this.search_word) {
        url.searchParams.append("search_word", this.search_word);
      }
      if (key && id) {
        url.searchParams.append(key, id);
      }
      window.location.href = url;
    },
  },
};
</script>
